import React, { FC } from "react";
import Hero from "../Hero/Hero";
import Carousel from "../Carousel/Carousel";
import Grid from "../Grid/Grid";
import Live from "../Live/Live";
import { PageSection } from "../../types";
import ContentFetch from "../../components/Fetch/ContentFetch";
import { User } from "../../utilities";

type ComponentListProps = {
  components: PageSection[];
  extraProps: any;
  enableAbroadBanner: () => void;
};

const ComponentList: FC<ComponentListProps> = ({ components, extraProps, enableAbroadBanner }) => {
  return (
    <React.Fragment>
      {
        components && components.length &&
        components
          .filter(component => component && component.collection && component.collection.nodes && (component.collection.nodes.length > 0 || component.type == "continue_watching")) // 👈 filter out empty or missing nodes
          .map((component, index) => {
            const { type } = component;
            const id = component.header ? `${component.header.replace(/ /g, "")}-${index}` : index;
            const key = `${type}-${id}`;
            const position = index + 1;

            switch (type) {
              case "Live":
                return (
                  <Live
                    key={key}
                    component={component}
                    {...extraProps}
                    enableAbroadBanner={enableAbroadBanner}
                  />
                );
              case "hero":
                return (
                  <Hero
                    key={key}
                    position={position}
                    component={component}
                    {...extraProps}
                    enableAbroadBanner={enableAbroadBanner}
                  />
                );
              case "carousel":
                return (
                  <Carousel
                    key={key}
                    position={position}
                    component={component}
                    {...extraProps}
                    enableAbroadBanner={enableAbroadBanner}
                  />
                );
              case "continue_watching":
                if (!User.authenticated()) {
                  return null;
                }

                return (
                  <ContentFetch key={key+"-cf"} viewAllPath="/content/continuity" isContinueWatching={true}>
                    {(errors, data) => (
                     (!data || errors || data?.collection?.nodes.length < 1) ? null :
                    <Carousel
                      key={key}
                      position={position}
                      component={{...component,...data}}
                      {...extraProps}
                      enableAbroadBanner={enableAbroadBanner}
                    />
                    )}
                  </ContentFetch>
                );
              case "grid":
                return (
                  <Grid
                    key={key}
                    position={position}
                    component={component}
                    {...extraProps}
                    enableAbroadBanner={enableAbroadBanner}
                  />
                );
              default:
                return null;
            }
          })
      }
    </React.Fragment>
  );
};

export default ComponentList;
